import { IconButton, BUTTON_VARIANTS, BUTTON_SIZES } from 'ui/button';
import { Exit24 } from 'ui/icons';

import { useJourneyAssistContext } from 'modules/workflows/context/JourneyAssistContext';
import { ToggleType } from './JourneyAssist.constants';
import { StyledHeader, StyledHeaderLeft, StyledHeaderRight } from './JourneyAssistDialog.styled';
import { TermsPopover } from './TermsPopover';

export const DIALOG_CLOSE_BUTTON_TEST_ID = 'journey-assist-close-button';

type PromptEditProps = {
  onCloseDialog: () => void;
  addOrReplace?: string;
  showToggle?: boolean;
};

export const DefaultHeader = ({ onCloseDialog, addOrReplace, showToggle }: PromptEditProps) => {
  const { promptType } = useJourneyAssistContext();

  const headerText = () => {
    if (!showToggle && addOrReplace === ToggleType.Replace) return 'Replace selected tiles';
    if (!showToggle && addOrReplace === ToggleType.Add) return 'Add tiles to path';
    return `Generate ${promptType}`;
  };

  return (
    <StyledHeader shiftRight>
      <StyledHeaderLeft>{headerText()}</StyledHeaderLeft>{' '}
      <StyledHeaderRight>
        <TermsPopover />
        <IconButton
          variant={BUTTON_VARIANTS.GHOST}
          data-test={DIALOG_CLOSE_BUTTON_TEST_ID}
          onClick={onCloseDialog}
          size={BUTTON_SIZES.LARGE}
        >
          <Exit24 />
        </IconButton>
      </StyledHeaderRight>
    </StyledHeader>
  );
};
